import React from 'react';
import { Space, Table, Tag } from 'antd';
const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    // render: (text) => <a>{text}</a>,
  },
  {
    title: 'Age',
    dataIndex: 'age',
    key: 'age',
  },
  {
    title: 'Address',
    dataIndex: 'address',
    key: 'address',
    // Other configurations for the 'Address' column
    //responsive: ['sm'], // Define the breakpoint for responsiveness
    ellipsis: true, // Enable ellipsis for overflow
    onCell: () => {
      return {
        style: {
          whiteSpace: 'wrap', // Prevent text from wrapping
          minWidth: '400px', // Set a max-width if needed
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      };
    },
  },
  {
    title: 'Tags',
    key: 'tags',
    dataIndex: 'tags',
    render: (_, { tags }) => (
      <>
        {tags.map((tag) => {
          let color = tag.length > 5 ? 'geekblue' : 'green';
          if (tag === 'loser') {
            color = 'volcano';
          }
          return (
            <Tag color={color} key={tag}>
              {tag.toUpperCase()}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: 'Action',
    key: 'action',
    render: (_, record) => (
      <Space size='middle'>
        <a>Invite {record.name}</a>
        <a>Delete</a>
      </Space>
    ),
  },
];
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
    tags: ['nice', 'developer'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'London No. 1 Lake Park, London No. 1 Lake Park, London No. 1 Lake Park, London No. 1 Lake Park, London No. 1 Lake Park, London No. 1 Lake Park.',
    tags: ['loser'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 32,
    address: 'Sydney No. 1 Lake Park',
    tags: ['cool', 'teacher'],
  },
];
export const TableAntDesign = () => (
  <div className='row'>
        <Table scroll={ {x:true} } expandable={true} columns={columns} dataSource={data} />
  </div>
);
// export default App;
